import './theme.scss';
import { NotificationBanner } from './components/NotificationBanner';
import { SiteHeader } from './components/SiteHeader';

document.querySelectorAll( '[data-global="notification-banner"]' ).forEach( ( banner ) => {
	new NotificationBanner( banner );
} );

document.querySelectorAll( '[data-global="header"]' ).forEach( ( header ) => {
	new SiteHeader( header );
} );
